<!--
@作者 王
@创建于 2021/3/1 17:07
-->

<template>
  <edit-dialog :width="width" @sureBack="onSubmit" :formData="editFormData" :title="title" ref="editDialog">
    <template v-for="data in editFormData" :slot="data.name" slot-scope="value">
      <slot :name="data.name" :data="value">
      </slot>
    </template>
  </edit-dialog>
</template>

<script>
    export default {
        name: "unitEdit",
        props:{
            editFormData:{
                type:Array
            },
            updateApi:{
                type:Function
            },
            changeDetail:{
                type:Function
            },
            changeSubmit:{
                type:Function
            },
            addApi:{
                type:Function
            },
            getDetailApi:{
                type:Function
            },
          width:{
              type:String
          }

        },
        data(){
            return {
                oldData: null,
                title:''
            }
        },
        methods:{
            onSubmit(data){
                if (this.oldData){
                    let json = {
                        ...this.oldData,...data
                    };
                    // console.log(this.changeSubmit)
                    if (this.changeSubmit)this.changeSubmit(json)
                    this.updateApi(json).then(()=>{
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.$emit('updateList')
                    })
                }else{
                    // console.log(this.changeSubmit)
                    if (this.changeSubmit)this.changeSubmit(data)
                    this.addApi(data).then(()=>{
                        this.$message({
                            message: '保存成功',
                            type: 'success'
                        });
                        this.$emit('updateList')
                    })
                }
            },
            async onShow(data){
                console.log(data)
                this.oldData = null;

                if (data){
                    this.title = '编辑';
                    this.getDetailApi(data).then(async (res)=>{
                        this.$refs.editDialog.show();
                        if (this.changeDetail){
                            res =await this.changeDetail(res);
                        }
                        this.oldData = res;
                        this.$nextTick(()=>{
                            this.$refs.editDialog.setAllDate(res);
                        })
                    })
                }else{
                    this.title = '新增';
                    this.$refs.editDialog.show();
                    this.$nextTick(()=>{
                        this.$refs.editDialog.clearAll();
                    })
                }
            }
        }
    }
</script>

<style lang="less">

</style>
